import React from 'react';
import ModernNavbar from '../../MicrospecDynamicUI/Pages/SectionsMapper/Navbar/ModernNavbar';
import { ModernNavbarSpec } from '../../MicrospecDynamicUI/Pages/SectionsMapper/Navbar/ModernNavbar/types';
import { commonNavLinks } from './commonNavLinks';

const spec: ModernNavbarSpec = {
    sticky: true,
    menuItems: commonNavLinks,
    applicationLogoSx: {
        maxWidth: 260,
        width: 260,
        height: 120,
    },
    showThemeModeToggler: false,
};

const CommonNavbar: React.FC = () => {
    return <ModernNavbar spec={spec} />;
};

export default CommonNavbar;
